import React, {useEffect, useState} from 'react';
import {
    AppBar,
    Avatar,
    Box,
    Button,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    Popover,
    TextField,
    Typography
} from '@mui/material';
import {FaBars} from '@react-icons/all-files/fa/FaBars';
import {FaChartLine} from '@react-icons/all-files/fa/FaChartLine';
import {FaDiceD6} from '@react-icons/all-files/fa/FaDiceD6';
import {FaCalendarAlt} from '@react-icons/all-files/fa/FaCalendarAlt';
import {FaCheckCircle} from '@react-icons/all-files/fa/FaCheckCircle';
import {FaFileInvoice} from '@react-icons/all-files/fa/FaFileInvoice';
import {FaSignOutAlt} from '@react-icons/all-files/fa/FaSignOutAlt';
import {FaUsers} from '@react-icons/all-files/fa/FaUsers';
import {FaDatabase} from '@react-icons/all-files/fa/FaDatabase';
import {FaSave} from '@react-icons/all-files/fa/FaSave';
import {Route, Routes, useLocation, useNavigate} from 'react-router-dom';
import {StyledListItemButton, StyledListItemText} from '../styles/CssStyled';
import MyContext from '../context/Context';
import ListaVersOre from "../pages/gestversore/ListaVersOre";
import ListaVersOre2 from "../pages/gestversore2/ListaVersOre2";
import ListaDatiProg from "../pages/gestdatiprog/ListaDatiProg";
import ListaValVersOre from "../pages/gestvalversore/ListaValVersOre";
import ListaPianAtt from "../pages/gestpianatt/ListaPianAtt";
import ListaDipProg from "../pages/gestdipprog/ListaDipProg";
import ListaReportClientiVersore from "../pages/reportclientiversore/ListaReportClientiVersore";
import Calendario from "../pages/calendario/Calendario";
import ListaReportRefVersore from "../pages/reportrefversore/ListaReportRefVersore";
import ListaReportAgentiVersore from "../pages/reportagentiversore/ListaReportAgentiVersore";
import ListaReportSospVersore from "../pages/reportsospversore/ListaReportSospVersore";
import ListaReportCliIns from "../pages/reportcliins/ListaReportCliIns";
import ListaReportBi from "../pages/reportbi/ListaReportBi";
import ListaNC from "../pages/gestnc/ListaNC";
import ListaRic from "../pages/gestric/ListaRic";
import {useKeycloak} from '@react-keycloak/web/lib/useKeycloak';
import Logout from "../auth/Logout";
import CalPianAtt from "../pages/gestpianatt/CalPianAtt";
import GanttPianAtt from "../pages/gestpianatt/GanttPianAtt";
import ListaMonitorProgettiRiepilogo from "../pages/monitorprogetti/ListaMonitorProgettiRiepilogo";
import ListaMonitorRisorse from "../pages/monitorisorse/ListaMonitorRisorse";
import ListaMonitorValVersOre from "../pages/monitorvalversore/ListaMonitorValVersOre";
import Preventivi from "../pages/gestprev/Preventivi";
import {FlowProgetti} from "../pages/gestflow/FlowProgetti";
import ListaRisorsaCalDav from "../pages/gestcaldav/ListaRisorsaCalDav";
import MioCalendarioCalDav from "../pages/gestcaldav/MioCalendarioCalDav";


export default function Sidebar(props: any) {
    const navigate = useNavigate()
    const {keycloak} = useKeycloak();
    const location = useLocation()
    const [screen, setScreen] = useState('ListaVersOre')
    const [drawerWidth, setDrawerWidth] = useState(180)
    const [headerWidth, setHeaderWidth] = useState(drawerWidth)
    const [userDetail, setUserDetail] = useState('')
    const [username, setUsername] = useState('');
    const [role, setRole] = useState<string[]>([]);
    const [impcoddip, setImpCodDip] = useState('NN');
    const [impditta, setImpDitta] = useState('0');



    useEffect(() => {
    const username = localStorage.getItem('keyusername');
    const storedRole = localStorage.getItem('keyrole');

    if (username) {
        setUsername(username);
    }
    try {
        const parsedRole = storedRole ? JSON.parse(storedRole) : [];
        setRole(parsedRole); // This is now an array
    } catch (e) {
        console.error('Failed to parse roles from localStorage:', storedRole);
        setRole([]);
    }
}, []);


  const baseNavList =
  Array.isArray(role)
    ? (NAVCONFIG.find(cfg =>
        (cfg.roles?.some(r => role.includes(r)) ?? false) ||
        (cfg.users?.includes(username) ?? false)
      )?.nav ?? [])
    : [];

  const hasAnyRole = (allowedRoles: string[]) =>
    Array.isArray(role) && allowedRoles.some((r) => role.includes(r));

  const canSeeMioCalDav =
    hasAnyRole(["TimeReportUser", "TimeReportAdmin", "TimeReportComm"]) &&
    hasAnyRole(["DmsAdmin", "DmsSvil", "DmsErp", "DmsCommerciale", "DmsBS"]);

  const navList =
    canSeeMioCalDav && !baseNavList.includes("miocaldav")
      ? [...baseNavList, "miocaldav"]
      : baseNavList;



useEffect(() => {
    const pathParts = location.pathname.split('/');
    const currentPath = pathParts[pathParts.length - 1]; // Get last part of URL

    if (navList.includes(currentPath)) {
        setScreen(currentPath);
    } else if (navList.length > 0) {
        // Redirect to the first item if no valid path is found
        const firstItem = navList[0];
        setScreen(firstItem);
        navigate(`/app/${firstItem}`, { replace: true }); // Prevents back navigation
    }
}, [location.pathname, navList, navigate]);



    // const navList = ['listaversore','valversore','listareportclientiversore','dash']
    const navIcons = (text: any, screen: any): React.ReactNode => {
        switch (text) {
            case 'listaversore':
                return screen === 'ListaVersOre' ? <FaUsers fill='#2a6db6' /> : <FaUsers />
           // case 'listaversore2':
            //     return screen === 'ListaVersOre2' ? <FaUsers fill='#2a6db6' /> : <FaUsers />
            case 'calendario':
                return screen === 'Calendario' ? <FaCalendarAlt fill='#2a6db6' /> : <FaCalendarAlt />
             case 'listavalversore':
                return screen === 'ListaValVersOre' ? <FaCheckCircle fill='#2a6db6' /> : <FaCheckCircle />
             case 'listareportrefversore':
                return screen === 'ListaReportRefVersore' ? <FaFileInvoice fill='#2a6db6' /> : <FaFileInvoice />
             case 'listareportclientiversore':
                return screen === 'ListaReportClientiVersore' ? <FaFileInvoice fill='#2a6db6' /> : <FaFileInvoice />
             case 'listareportagentiversore':
                return screen === 'ListaReportAgentiVersore' ? <FaFileInvoice fill='#2a6db6' /> : <FaFileInvoice />
             case 'listareportsospversore':
                return screen === 'ListaReportSospVersore' ? <FaFileInvoice fill='#2a6db6' /> : <FaFileInvoice />
             case 'listareportcliins':
                return screen === 'ListaReportCliIns' ? <FaFileInvoice fill='#2a6db6' /> : <FaFileInvoice />
             case 'listamonitorprogettiriepilogo':
                return screen === 'ListaMonitorProgettiRiepilogo' ? <FaFileInvoice fill='#2a6db6' /> : <FaFileInvoice />
             case 'listamonitorrisorse':
                return screen === 'ListaMonitorRisorse' ? <FaFileInvoice fill='#2a6db6' /> : <FaFileInvoice />
             case 'listamonitorvalversore':
                return screen === 'ListaMonitorValVersOre' ? <FaFileInvoice fill='#2a6db6' /> : <FaFileInvoice />
            case 'listareportbi':
                return screen === 'ListaReportBi' ? <FaChartLine fill='#2a6db6' /> : <FaChartLine />
            case 'listadatiprog':
                return screen === 'ListaDatiProg' ? <FaDatabase fill='#2a6db6' /> : <FaDatabase />
            case 'listapianatt':
                return screen === 'ListaPianAtt' ? <FaCalendarAlt fill='#2a6db6' /> : <FaCalendarAlt />
            case 'calpianatt':
                return screen === 'CalPianAtt' ? <FaCalendarAlt fill='#2a6db6' /> : <FaCalendarAlt />
            case 'ganttpianatt':
                return screen === 'GanttPianAtt' ? <FaCalendarAlt fill='#2a6db6' /> : <FaCalendarAlt />
            case 'listadipprog':
                return screen === 'ListaDipProg' ? <FaUsers fill='#2a6db6' /> : <FaUsers />
            case 'preventivi':
                return screen === 'Preventivi' ? <FaUsers fill='#2a6db6' /> : <FaUsers />
            case 'prevtemp':
                return screen === 'PrevTemp' ? <FaUsers fill='#2a6db6' /> : <FaUsers />
             case 'listanc':
                return screen === 'ListaNC' ? <FaUsers fill='#2a6db6' /> : <FaUsers />
             case 'listaric':
                return screen === 'ListaRic' ? <FaUsers fill='#2a6db6' /> : <FaUsers />
            case 'flowprogetti':
                return screen === 'FlowProgetti' ? <FaUsers fill='#2a6db6' /> : <FaUsers />
            case 'risorsacaldav':
                return screen === 'ListaRisorsaCalDav' ? <FaCalendarAlt fill='#2a6db6' /> : <FaCalendarAlt />
            case 'miocaldav':
                return screen === 'MioCalendarioCalDav' ? <FaCalendarAlt fill='#2a6db6' /> : <FaCalendarAlt />
            default: return <FaDiceD6 fill='#2a6db6' />

        }
    }

    const menuLabels: { [key: string]: string } = {
        listaversore: "Time Report",
        listaversore2: "Time Report 2",
        calendario: "Calendario",
        listavalversore: "Validazione",
        listareportrefversore: "Report Ref.",
        listareportclientiversore: "Report Clienti",
        listareportagentiversore: "Report Agenti",
        listareportsospversore: "Report Sosp.",
        listareportcliins: "Report Cli.Sosp.",
        listamonitorprogettiriepilogo: "Mon.Progetti",
        listamonitorrisorse: "Mon.Risorse",
        listamonitorvalversore: "Mon.ValVersOre",
        listareportbi: "Report BI",
        listadatiprog: "Dati Progetti",
        listapianatt: "Pian.Attivita",
        calpianatt: "Cal.Pian.Att.",
        ganttpianatt: "Gantt.Pian.Att.",
        listadipprog: "Dip.Progetti",
        dropdipprog: "Drop Dip.Prog.",
        preventivi: "Preventivi",
        prevtemp: "Prev.Temp.",
        flowprogetti: "Flow Prog.",
        listanc: "Gest.NC",
        listaric: "Gest.Richieste",
        risorsacaldav: "CalDAV Risorse",
        miocaldav: "Mio Calendario",

};


    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        // userProfile();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const isIframe = window.self !== window.top;
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const iframeContentOffset = isIframe ? '-60px' : '0px';
    // console.log(screen, 'sidebar');
    const context = { drawerWidth: drawerWidth, screen: screen }
    return (
        <>
            <Box>
                <AppBar position="fixed"
                    sx={{
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                        display: isIframe ? 'none' : 'flex',
                        height: isIframe ? '0px' : '50px',
                        backgroundColor: '#2a6db6',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        // boxShadow: 'none',
                        // borderBottom: `0.5px solid #0000001f`
                        boxShadow: '1px'
                    }}
                >
                    <Box style={{marginLeft: '20px', marginRight: '1px', display: 'flex', flexDirection: 'row', alignItems: 'center'  }}>
                        {/*<Toolbar>*/}
                            {/*{drawerWidth === 60 ? <img src={logo} width={'40px'} style={{ transform: 'rotate(270deg)', marginLeft: '-15px', marginRight: '10px' }} /> : <img src={logo} width={'100px'} style={{ marginLeft: '-5px', marginRight: '30px' }} />}*/}
                            <IconButton sx={{ ml: '-10px',  color: 'white' }} onClick={() => setDrawerWidth(drawerWidth === 60 ? 180 : 60)}>
                                <FaBars style={{ height: '20px' }} />
                            </IconButton>
                           <Typography sx={{ fontWeight: 'bold', color: 'white',  fontSize: '20px', alignItems: 'center' }}>
                                {menuLabels[screen] || screen}
                            </Typography>

                        {/*</Toolbar>*/}
                    </Box>
                    <Box style={{
                        marginRight: '10px',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                    }}>
                    {!isIframe && (
                        <Typography sx={{ fontWeight: 'bold', color: 'white', mr: 2 }}>
                            {username}
                        </Typography>
                    )}
                        {/* <IconButton onClick={userProfile} sx={{ mr: 2 }}><FaCog /></IconButton> */}
                    {!isIframe && (
                        <IconButton onClick={handleClick} sx={{ mr: 3 }}>
                            <Avatar
                                // src='hj'
                                sx={{ height: '27px', width: '27px' }}
                            />
                        </IconButton>
                    )}
                        <Popover
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                        >
                            <List disablePadding>
                                   <ListItem/>
                            {role.includes('TimeReportAdmin') && (      <ListItem disablePadding sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <TextField
                                                    label="ImpDip NN all"
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{
                                                        width: '100px', // Make the input smaller
                                                        fontSize: '0.65rem', // Smaller font size
                                                        '& .MuiInputBase-root': { height: 25 }, // Even smaller input height
                                                    }}
                                                    onChange={(e) => setImpCodDip(e.target.value)}
                                                />
                                                <TextField
                                                    label="Ditta"
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{
                                                        width: '100px', // Make the input smaller
                                                        fontSize: '0.65rem', // Smaller font size
                                                        '& .MuiInputBase-root': { height: 25 }, // Even smaller input height
                                                    }}
                                                    onChange={(e) => setImpDitta(e.target.value)}
                                                />
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    sx={{
                                                        minWidth: 'auto',
                                                        padding: '2px 6px', // Smaller padding
                                                        fontSize: '0.65rem', // Smaller font size
                                                        height: '24px', // Even smaller button height
                                                    }}
                                                    onClick={() => {
                                                        localStorage.setItem('impcoddip', impcoddip);
                                                        localStorage.setItem('impditta', impditta);
                                                        console.log('impcoddip set in localStorage:', impcoddip);
                                                        console.log('impditta set in localStorage:', impditta);
                                                    }}
                                                    startIcon={<FaSave />}
                                                >
                                                </Button>
                                            </ListItem>
                                    )}

                                    <ListItem disablePadding>
                                        <StyledListItemButton onClick={() => {
                                            navigate('logout')
                                            // handleLogout();
                                            // keycloak?.logout();
                                        }}>
                                            <ListItemIcon > <FaSignOutAlt fill='#2a6db6' /></ListItemIcon>
                                            <StyledListItemText primary={'Logout'} sx={{ ml: '-20px', color: '#2a6db6' }} />
                                        </StyledListItemButton>
                                    </ListItem>

                            </List>
                        </Popover>
                    </Box>
                </AppBar>

                <Drawer
                    variant="permanent"
                    sx={{
                        width: drawerWidth,
                        [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' }
                    }}
                >
                    <Box sx={{ width: drawerWidth, marginTop: 0 }}>
                        <List sx={{ pt: isIframe ? 0 : '65px' }}>
                            {navList.map((text, index) => (
                                <ListItem key={text} disablePadding  >
                                    <StyledListItemButton
                                        sx={{ pt: '6px', pb: '6px' }}
                                        onClick={() => {
                                            navigate(`/app/${text}`)
                                            setScreen(text)
                                        }}
                                        selected={screen === text}
                                    >
                                        <ListItemIcon sx={{ ml: '5px' }}>
                                            {navIcons(text, screen)}
                                        </ListItemIcon>
                                        <StyledListItemText primary={menuLabels[text] || text} sx={{ ml: -2, textTransform: 'capitalize' }} />

                                        {/*<StyledListItemText primary={text} sx={{ ml: -2, textTransform: 'capitalize' }} />*/}
                                    </StyledListItemButton>
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                </Drawer>
                <MyContext.Provider value={context}>
                   {/*<Box sx={{ width: drawerWidth === 60 ? '1380px' : '1240px', ml: drawerWidth === 60 ? '60px' : '200px', overflowX: 'hidden' }}>*/}
                    <Box sx={{ width: 'auto', ml: drawerWidth === 60 ? '60px' : '180px', mt: iframeContentOffset, overflowX: 'hidden' }}>
                        <Routes key={screen}>
                         {/*<Route index element={<ListaVersOre />} />*/}
                         <Route path='listaversore' element={<ListaVersOre2   />} />
                         {/*<Route path='listaversore2' element={<ListaVersOre2   />} />*/}
                         <Route path='calendario' element={<Calendario   />} />
                         <Route path='listavalversore' element={<ListaValVersOre  />} />
                         <Route path='listareportrefversore' element={<ListaReportRefVersore  />} />
                         <Route path='listareportagentiversore' element={<ListaReportAgentiVersore  />} />
                         <Route path='listareportsospversore' element={<ListaReportSospVersore  />} />
                         <Route path='listareportclientiversore' element={<ListaReportClientiVersore  />} />
                         <Route path='listareportcliins' element={<ListaReportCliIns  />} />
                         <Route path='listamonitorprogettiriepilogo' element={<ListaMonitorProgettiRiepilogo  />} />
                         <Route path='listamonitorrisorse' element={<ListaMonitorRisorse  />} />
                         <Route path='listamonitorvalversore' element={<ListaMonitorValVersOre  />} />
                         <Route path='listareportbi' element={<ListaReportBi />} />
                         <Route path='listadatiprog' element={<ListaDatiProg />} />
                         <Route path='listapianatt' element={<ListaPianAtt />} />
                         <Route path='calpianatt' element={<CalPianAtt />} />
                         <Route path='ganttpianatt' element={<GanttPianAtt />} />
                         <Route path='listadipprog' element={<ListaDipProg />} />
                         <Route path='preventivi' element={<Preventivi key="preventivi"  propflgtemp='N' />} />
                         <Route path='prevtemp' element={<Preventivi key="template" propflgtemp='Y' />} /> {/* Force reload using key */}
                         <Route path='flowprogetti' element={<FlowProgetti/>} />
                         <Route path='listanc' element={<ListaNC/>} />
                         <Route path='listaric' element={<ListaRic/>} />
                         <Route path='risorsacaldav' element={<ListaRisorsaCalDav />} />
                         <Route path='miocaldav' element={<MioCalendarioCalDav />} />
                         <Route path='logout' element={<Logout key="logout" />} />
                        </Routes>
                    </Box>
                   {/*</Box>*/}
                </MyContext.Provider>

            </Box >
        </>

    )
}
